export default "__VITE_ASSET__zlWX6vrR__"